import React from 'react';
import ListarIngresos from '../../../components/insumos/ingresos/ListarIngresos';
import { PageWrapper } from '../../../components/common';

const ListarIngresosPage: React.FC = () => {
  return (
    <PageWrapper>
      <ListarIngresos />
    </PageWrapper>
  );
};

export default ListarIngresosPage;
